export default __webpack_public_path__ + "static/media/empty_state.c7db27a0.png";